export default __webpack_public_path__ + "static/media/button_icon_01.ba162f21.svg";